export enum DeviceStatusReason {
  online = 'online',
  paused = 'paused',
  standby = 'standby',
  offline = 'offline',
  notReady = 'not-ready',
  transducerDisconnected = 'transduc-discon',
  hardwareDisconnected = 'hw-discon',
  off = 'off',
}

export const DeviceStatusReasonDescription: Record<DeviceStatusReason, string> =
  {
    [DeviceStatusReason.online]: 'The device is online',
    [DeviceStatusReason.paused]: 'The device is paused',
    [DeviceStatusReason.standby]:
      'The device is ready but not actively operating',
    [DeviceStatusReason.offline]: 'The device is offline',
    [DeviceStatusReason.notReady]: 'The device is not ready',
    [DeviceStatusReason.transducerDisconnected]:
      'The device transducer is disconnected',
    [DeviceStatusReason.hardwareDisconnected]:
      'The device hardware is disconnected',
    [DeviceStatusReason.off]: 'The device is off',
  };

export enum DeviceCode {
  relay = 'device.relay',
  patch = 'device.patch',
  band = 'device.band',
  glucose = 'device.glucose',
  bloodPressure = 'device.bloodpressure',
}
